import React, { Component } from "react";
import Header from "./Header";

import { Container, Form, Button } from "react-bootstrap";
import FooterHome from "./FooterHome";
import utils from "../config/js/utils";

const axios = require("axios");
export default class Consult extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      phonenumber: "",
      dateofbirth: "",
      policyid: "",
      symptoms: "",
      ack: "off",
      submitBtn: "",
      source: navigator.userAgent,
      city: "",
      district: "",
      customerType: "Retail",
      membershipid: "",
      productname: "",
      companyname: "",
      employeeid: "",
      others: "",
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleName = this.handleName.bind(this);
    this.handleEmail = this.handleEmail.bind(this);
    this.handlePhonenumber = this.handlePhonenumber.bind(this);
    this.handleDateOfBirth = this.handleDateOfBirth.bind(this);
    this.handleSymptoms = this.handleSymptoms.bind(this);
    this.handlePolicyid = this.handlePolicyid.bind(this);
    this.handleAck = this.handleAck.bind(this);
    this.handleType = this.handleType.bind(this);
    this.handleProductName = this.handleProductName.bind(this);
    this.handleCompanyName = this.handleCompanyName.bind(this);
    this.handleEmployeeId = this.handleEmployeeId.bind(this);
    this.handleMembership = this.handleMembership.bind(this);
    this.handleCity = this.handleCity.bind(this);
    this.handleDistrict = this.handleDistrict.bind(this);
    this.handleOthers = this.handleOthers.bind(this);
  }

  handleName(event) {
    this.setState({
      name: event.target.value,
    });
  }

  handleType(event) {
    this.setState({
      customerType: event.target.value,
    });
  }

  handleProductName(event) {
    this.setState({
      productname: event.target.value,
    });
  }

  handleCompanyName(event) {
    this.setState({
      companyname: event.target.value,
    });
  }

  handleEmployeeId(event) {
    this.setState({
      employeeid: event.target.value,
    });
  }

  handleMembership(event) {
    this.setState({
      membershipid: event.target.value,
    });
  }

  handleCity(event) {
    this.setState({
      city: event.target.value,
    });
  }

  handleDistrict(event) {
    this.setState({
      district: event.target.value,
    });
  }

  handleOthers(event) {
    this.setState({
      others: event.target.value,
    });
  }

  handleEmail(event) {
    this.setState({
      email: event.target.value,
    });
  }

  handlePhonenumber(event) {
    this.setState({
      phonenumber: event.target.value,
    });
  }

  handleDateOfBirth(event) {
    this.setState({
      dateofbirth: event.target.value,
    });
  }

  handleSymptoms(event) {
    this.setState({
      symptoms: event.target.value,
    });
  }

  handlePolicyid(event) {
    this.setState({
      policyid: event.target.value,
    });
  }

  handleAck(event) {
    let val = "off";
    if (this.state.ack === "off") {
      val = "on";
    }
    this.setState({
      ack: val,
    });
  }

  async handleSubmit(event) {
    event.preventDefault();
    this.setState({
      submitBtn: "disabled",
    });
    if (
      this.state.customerType == "Retail" &&
      (this.state.policyid.length != 14 || this.state.policyid[0] != 0)
    ) {
      alert("please enter correct Policy Id");
    } else if (
      this.state.customerType == "Retail" &&
      this.state.membershipid &&
      (this.state.membershipid.length != 10 || this.state.membershipid[0] == 0)
    ) {
      alert("Please enter correct Membership Id");
    } else {
      try {
        console.log(this.state);
        let result = await axios.post(
          "https://uberbackend.docsapp.in/maxbupa/createConsult",
          this.state
        );
        // let result = await axios.post('http://localhost:8080/maxbupa/createConsult', this.state)
        console.log(result);
        if (result && result.data.success) {
          /*         alert("Your booking is successful. We have shared your booking details on your email id and sms. Doctor from DocsApp will call you within 30 minutes. Please attend the call. Wish you good health!"); */

          this.setState({
            name: "",
            email: "",
            phonenumber: "",
            dateofbirth: "",
            policyid: "",
            symptoms: "",
            ack: "off",
            submitBtn: "",
            source: navigator.userAgent,
            city: "",
            district: "",
            customerType: "Retail",
            membershipid: "",
            productname: "",
            companyname: "",
            employeeid: "",
            others: "",
          });

          this.props.history.push(`/thankyou`);
        } else {
          alert("Failed to Create Consultation");
        }
      } catch (e) {
        console.error(e);
        alert("Failed to Create Consultation");
      }
    }
  }
  policyTypeInput(type) {
    if (type == "Retail") {
      return (
        <Form.Group>
          <Form.Label>Max Bupa Policy No </Form.Label>
          <span style={{ color: "red", paddingLeft: "2px" }}>&#42;</span>
          <Form.Control
            required
            value={this.state.policyid}
            type="number"
            placeholder="Max Bupa Policy No"
            onChange={this.handlePolicyid}
          />
          <Form.Text className="text-muted">
            Enter Your Existing Max Bupa Policy No
          </Form.Text>
        </Form.Group>
      );
    } else {
      return (
        <Form.Group>
          <Form.Label>
            Max Bupa Policy No <i>(Optional)</i>{" "}
          </Form.Label>
          <Form.Control
            value={this.state.policyid}
            type="number"
            placeholder="Max Bupa Policy No"
            onChange={this.handlePolicyid}
          />
          <Form.Text className="text-muted">
            Enter Your Existing Max Bupa Policy No(if Any)
          </Form.Text>
        </Form.Group>
      );
    }
  }

  corpInput(type) {
    if (type == "Retail") {
      return (
        <>
          <Form.Group>
            <Form.Label>
              Company Name <i>(Optional)</i>{" "}
            </Form.Label>
            <Form.Control
              value={this.state.companyname}
              type="text"
              placeholder="Enter Company Name"
              onChange={this.handleCompanyName}
            />
            <Form.Text className="text-muted">
              Enter Company Name(if Any)
            </Form.Text>
          </Form.Group>
          <Form.Group>
            <Form.Label>
              Employee Id <i>(Optional)</i>{" "}
            </Form.Label>
            <Form.Control
              value={this.state.employeeid}
              type="text"
              placeholder="Enter your Employee Id"
              onChange={this.handleEmployeeId}
            />
            <Form.Text className="text-muted">
              Enter your Employee Id(if Any)
            </Form.Text>
          </Form.Group>
        </>
      );
    } else {
      return (
        <>
          <Form.Group>
            <Form.Label>Company Name </Form.Label>
            <span style={{ color: "red", paddingLeft: "2px" }}>&#42;</span>
            <Form.Control
              required
              value={this.state.companyname}
              type="text"
              placeholder="Enter Company Name"
              onChange={this.handleCompanyName}
            />
            <Form.Text className="text-muted">Enter Company Name</Form.Text>
          </Form.Group>
          <Form.Group>
            <Form.Label>Employee Id </Form.Label>
            <span style={{ color: "red", paddingLeft: "2px" }}>&#42;</span>
            <Form.Control
              required
              value={this.state.employeeid}
              type="text"
              placeholder="Enter your Employee Id"
              onChange={this.handleEmployeeId}
            />
            <Form.Text className="text-muted">Enter your Employee Id</Form.Text>
          </Form.Group>
        </>
      );
    }
  }

  membershipidInput(type) {
    if (type == "Retail") {
      return (
        <Form.Group>
          <Form.Label>Max Bupa Membership Id </Form.Label>
          <Form.Control
            value={this.state.membershipid}
            type="text"
            placeholder="Max Bupa Membership Id"
            onChange={this.handleMembership}
          />
          <Form.Text className="text-muted">
            Enter Your Max Bupa Membership Id
          </Form.Text>
        </Form.Group>
      );
    } else {
      return (
        <Form.Group>
          <Form.Label>
            Max Bupa Membership Id <i>(Optional)</i>{" "}
          </Form.Label>
          <Form.Control
            value={this.state.membershipid}
            type="text"
            placeholder="Max Bupa Membership Id"
            onChange={this.handleMembership}
          />
          <Form.Text className="text-muted">
            Enter Your Max Bupa Membership Id(if Any)
          </Form.Text>
        </Form.Group>
      );
    }
  }

  render() {
    return (
      // <div className='mt-5'>
      <Container fluid style={{ paddingLeft: "0px", paddingRight: "0px" }}>
        <Header headerFlag={true} />
        <Container>
          <br />
          <div style={{ textAlign: "center", color: "#00000" }}>
            Get Online Doctor Consultation in 30 minutes. Recover at home.
            Recover on time
          </div>
        </Container>

        <Container>
          <Form onSubmit={this.handleSubmit}>
            <Form.Group controlId="formBasicEmail">
              <Form.Label>Name</Form.Label>
              <span style={{ color: "red", paddingLeft: "2px" }}>&#42;</span>
              <Form.Control
                required
                value={this.state.name}
                type="text"
                placeholder="Enter Your Name"
                onChange={this.handleName}
                maxLength="70"
                pattern={"(?=.*[a-z])(?=.*[A-Z]).{4,14}"}
              />
              <br />
              <Form.Label>Email Id</Form.Label>
              <span style={{ color: "red", paddingLeft: "2px" }}>&#42;</span>
              <Form.Control
                required
                value={this.state.email}
                type="email"
                placeholder="Prescription will be mailed on this email id"
                onChange={this.handleEmail}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Select Date Of Birth</Form.Label>
              <span style={{ color: "red", paddingLeft: "2px" }}>&#42;</span>
              <Form.Control
                required
                value={this.state.dateofbirth}
                type="date"
                placeholder="Select your Date of Birth"
                onChange={this.handleDateOfBirth}
                max={utils.getPrevDate(6570)}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Enter Mobile Number</Form.Label>
              <span style={{ color: "red", paddingLeft: "2px" }}>&#42;</span>
              <Form.Control
                required
                value={this.state.phonenumber}
                type="number"
                placeholder="Enter your Mobile Number"
                onChange={this.handlePhonenumber}
                maxLength="10"
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>City</Form.Label>
              <span style={{ color: "red", paddingLeft: "2px" }}>&#42;</span>
              <Form.Control
                required
                value={this.state.city}
                type="text"
                placeholder="Enter your Home City"
                onChange={this.handleCity}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>District</Form.Label>
              <span style={{ color: "red", paddingLeft: "2px" }}>&#42;</span>
              <Form.Control
                required
                value={this.state.district}
                type="text"
                placeholder="Enter your Home District"
                onChange={this.handleDistrict}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Customer Type</Form.Label>
              <span style={{ color: "red", paddingLeft: "2px" }}>&#42;</span>
              <Form.Check
                checked={this.state.customerType == "Retail"}
                type="radio"
                label="Retail"
                name="customerType"
                value="Retail"
                id="Retail"
                onChange={this.handleType}
              />
              <Form.Check
                type="radio"
                label="Group"
                name="customerType"
                value="Group"
                id="Group"
                onChange={this.handleType}
              />
            </Form.Group>
            {this.policyTypeInput(this.state.customerType)}
            {this.membershipidInput(this.state.customerType)}
            <Form.Group>
              <Form.Label>
                Product Name <i>(Optional)</i>{" "}
              </Form.Label>
              <Form.Control
                value={this.state.productname}
                type="text"
                placeholder="Enter Product Name"
                onChange={this.handleProductName}
              />
              <Form.Text className="text-muted">
                Enter Product Name(if Any)
              </Form.Text>
            </Form.Group>
            {this.corpInput(this.state.customerType)}
            <Form.Group>
              <Form.Label>
                Tell us the symptom that’s bothering you most
              </Form.Label>
              <span style={{ color: "red", paddingLeft: "2px" }}>&#42;</span>
              <Form.Control
                required
                value={this.state.symptoms}
                type="text"
                placeholder="Please type your health issue in detail Eg. I am suffering from high fever and skin rashes since 2 days"
                onChange={this.handleSymptoms}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>
                Other <i>(Optional)</i>{" "}
              </Form.Label>
              <Form.Control
                value={this.state.others}
                type="text"
                placeholder="Something you would like to mention?"
                onChange={this.handleOthers}
              />
              <Form.Text className="text-muted">
                Something you would like to mention?
              </Form.Text>
            </Form.Group>

            <Form.Group controlId="formBasicCheckbox">
              <Form.Check
                required
                value={this.state.ack}
                type="checkbox"
                label={
                  this.state.ack
                    ? "I hereby  authorize Max Bupa Health Insurance to access my medical records from Docsapp, and also allow Max Bupa Health Insurance or any of its Agents and/or third party(ies)/ affiliates to contact me via SMS/Email/Phone/WhatsApp/Facebook or any other modes on my registered phone number over-riding my ‘DND’ registration to make welcome calls/SMS, service calls/SMS or any other commercial communication. *"
                    : ""
                }
                onChange={this.handleAck}
                style={{ fontSize: "10px" }}
              />
            </Form.Group>

            <div className="form-btn">
              <Button
                variant="primary"
                type="submit"
                style={{
                  backgroundColor: "rgba(241, 91, 97, 0.9)",
                  borderColor: "rgba(241, 91, 97, 0.9)",
                }}
              >
                Book Your e-Consultation
              </Button>
            </div>
          </Form>
          <br />
        </Container>
        <br />
        <FooterHome />
      </Container>
    );
  }
}
